// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__g-T45","title":"ClientReferral_title__3pKbD","itemText":"ClientReferral_itemText__3Rt9u"};